import React from 'react';

/**
 * Ligne de tableau P&L générique
 */
function PLTableRow({
  label,
  data,
  formatValue,
  style = {},
  labelStyle = {},
  valueStyle = {},
  indent = false
}) {
  const periods = ['Q1', 'Q2', 'Q3', 'Q4', 'ANNUEL'];

  return (
    <tr style={style}>
      <td style={{
        padding: '0.6rem 1rem',
        paddingLeft: indent ? '2rem' : '1rem',
        fontSize: '0.85rem',
        whiteSpace: 'nowrap',
        ...labelStyle
      }}>
        {label}
      </td>
      {periods.map(period => (
        <td key={period} style={{
          padding: '0.6rem 1rem',
          textAlign: 'right',
          fontSize: '0.85rem',
          whiteSpace: 'nowrap',
          ...valueStyle
        }}>
          {formatValue(data[period], period)}
        </td>
      ))}
    </tr>
  );
}

export default PLTableRow;
